export type OpenPageLookup = Record<string, boolean>

type PageWithOpen = object & {
  is_open?: boolean
  url: string
}

export const openPageLookupReducer = (acc: OpenPageLookup, page: PageWithOpen): OpenPageLookup => {
  acc[page.url] = !!page?.is_open
  return acc
}

export const getIdFromGoogleDocuments = (url: string): string | null => {
  const match = url?.match(/\/document\/d\/([a-zA-Z0-9-_]+)/)
  return match ? match[1] : null
}

export const getGoogleDocumentsPatternUrl = (id: string) => {
  return `https://*.google.com/document/d/${id}/*`
}

export const getIdFromGoogleSlides = (url: string): string | null => {
  const match = url?.match(/\/presentation\/d\/([a-zA-Z0-9-_]+)/)
  return match ? match[1] : null
}

export const getGoogleSlidesPatternUrl = (id: string) => {
  return `https://*.google.com/presentation/d/${id}/*`
}

export const getIdFromGoogleSheets = (url: string): string | null => {
  const match = url?.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/)
  return match ? match[1] : null
}

export const getGoogleSheetsPatternUrl = (id: string) => {
  return `https://*.google.com/spreadsheets/d/${id}/*`
}

export const getIdFromYouTubeSmallUrl = (url: string): string | null => {
  const match = url?.match(/youtu\.be\/([a-zA-Z0-9-_]+)/)
  return match ? match[1] : getIdFromYouTubeLongUrl(url)
}

export const getIdFromYouTubeLongUrl = (url: string): string | null => {
  const match = url?.match(/v=([a-zA-Z0-9-_]+)/)
  return match ? match[1] : null
}

export const getYouTubePatternUrl = (id: string) => {
  return `https://*.youtube.com/watch?v=${id}`
}

const urlPatterns = [
  {
    pattern: 'google.com/document/',
    getId: getIdFromGoogleDocuments,
    getPatternUrl: getGoogleDocumentsPatternUrl,
  },
  {
    pattern: 'google.com/presentation/d/',
    getId: getIdFromGoogleSlides,
    getPatternUrl: getGoogleSlidesPatternUrl,
  },
  {
    pattern: 'google.com/spreadsheets/d/',
    getId: getIdFromGoogleSheets,
    getPatternUrl: getGoogleSheetsPatternUrl,
  },
  { pattern: 'youtu.be', getId: getIdFromYouTubeSmallUrl, getPatternUrl: getYouTubePatternUrl },
  {
    pattern: 'youtube.com/watch',
    getId: getIdFromYouTubeLongUrl,
    getPatternUrl: getYouTubePatternUrl,
  },
]

export const isPageOpenByUrl = (openTab: OpenPageLookup = {}, url: string): boolean => {
  for (const { pattern, getId } of urlPatterns) {
    if (url?.includes(pattern)) {
      const id = getId(url)
      if (id) {
        const openTabKeys = Object.keys(openTab)
        const matchingKey = openTabKeys.find((key) => getId(key) === id)
        if (matchingKey) {
          return true
        }
      }
    }
  }

  return openTab?.[url] ?? false
}

export const getOpenTabUrl = (openTab: OpenPageLookup = {}, url: string): string => {
  for (const { pattern, getId, getPatternUrl } of urlPatterns) {
    if (url?.includes(pattern)) {
      const id = getId(url)
      if (id) {
        const openTabKeys = Object.keys(openTab)
        const matchingKey = openTabKeys.find((key) => getId(key) === id)
        if (matchingKey) {
          return getPatternUrl(id)
        }
      }
    }
  }

  return url
}
